module.exports = __webpack_public_path__ + "resources/img/facetec-ui-overlay.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/facetec-ui-overlay.png
// module id = 1366
// module chunks = 0